import styled from 'styled-components';
import media from 'styled-media-query';
import Image from 'next/legacy/image';

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  padding: 1.6rem;
  padding-bottom: 0;

  @media (min-width: 768px) {
    padding: 7.4rem;
    padding-bottom: 0;
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const VideoBox = styled.video<{ width: number; height: number }>`
  width: 100%;
  height: ${({ height }) => `${height}px`};
  position: relative;

  ${media.greaterThan<{ imageLeft?: boolean }>('medium')`
    order: ${({ imageLeft }) => (imageLeft ? 1 : 2)};
  `}
`;

export const CustomImage = styled(Image)`
  ${media.greaterThan<{ imageLeft?: boolean }>('medium')`
    border-radius: 1.2rem;
  `}
`;

export const InnerBox = styled.div<{ imageLeft?: boolean }>`
  padding: 3.6rem 2.4rem;
  margin: 1.6rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: 3.6rem;

  ${media.greaterThan<{ imageLeft?: boolean }>('medium')`
  margin: 0;
  width: 100%;
  order: ${({ imageLeft }) => (imageLeft ? 2 : 1)};
  `}
`;

export const ButtonsBox = styled.div`
  margin-top: auto;
  max-width: 38rem;
`;

export const Text = styled.p`
  line-height: 2.4rem;
  color: ${({ theme }) => theme.colors.gray2};
  text-align: start;
`;
